import React from 'react'

import './LoginBlock.css'

const LoginBlock = () => (
  <div className='l-container'>
    <section className='c-login-block'>
      <iframe
        title='login'
        width='100%'
        height='100%'
        src='https://portal.xelex.ai/login'
      />
    </section>
  </div>
)

export default LoginBlock
